<ng-container *transloco="let t">
  @if (!(componentType === EventDetailsComponentType.PREVIEW)) {
    <app-page-template>
      <ng-template *ngTemplateOutlet="page"></ng-template>
    </app-page-template>
  } @else {
    <ng-template *ngTemplateOutlet="page"></ng-template>
  }

  <ng-template #page>
    <div class="container pb-300-100">
      <div class="py-3 py-xxl-4 mb-3 mb-xxl-3">
        <!--        Lg view-->
        <div class="flex-column flex-md-row justify-content-start d-none d-xxl-flex">
          <div class="pe-4">
            <img src="{{event?.imageMedium || ''}}" alt="Event details" class="img-fluid img-size"
                 [sportOne]="event?.sportOne" [sportTwo]="event?.sportTwo" appImageFallback>
          </div>
          <div class="d-flex flex-column flex-grow-1 ps-0 ps-md-2">
            <div class="d-flex pt-2">
              <app-save-share [eventDetails]="event" [languages]="languages"
                              [isPreviewComponent]="componentType === EventDetailsComponentType.PREVIEW"/>
            </div>
            <div class="pb-2 pt-4">
              <h1>
                <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng"
                                     [itLabel]="event?.nameIta" [siLabel]="event?.nameSlo" [bsLabel]="event?.nameBs"
                                     [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
              </h1>
            </div>
            <div class="pb-3 d-flex">
              <ng-container *ngTemplateOutlet="sportBadge; context: { event: event, t: t }"></ng-container>
            </div>
            <div class="d-flex pb-1 align-items-center">
              <div class="pe-2 d-flex">
                <img src="assets/icons/icons-alt/route-alt.svg" alt="Location"/>
              </div>
              <p class="regular">
                @for (length of lengths;track length;let idx = $index) {
                  <span>
                {{length | raceLengthFormat:translocoService.getActiveLang()}}
                </span>
                  @if ((idx < lengths.length - 1)) {
                    <span class="race-length-wrapper__separator">|</span>
                  }
                }
              </p>
            </div>
            <div class="d-flex pb-1 align-items-center">
              <div class="pe-2 d-flex">
                <img src="assets/icons/icons-alt/location-alt.svg" alt="Location"/>
              </div>
              <p class="regular">
                @if (event?.city) { {{event?.city}}}
                @if (event?.country) {{{','}} }
                @if (eventCountry?.iocCode) { {{eventCountry?.iocCode}} }
              </p>
            </div>
            <div class="d-flex pb-1 align-items-center">
              <div class="ps-1 d-flex" style="padding-right: 0.7rem;">
                <img src="assets/icons/icons-alt/calendar-04.svg" alt="Start time"/>
              </div>
              <p class="regular">
                <app-event-date-display [eventItem]="event"/>
              </p>
            </div>
            <ng-container *ngTemplateOutlet="competitorCount; context: { event: event, t: t }"></ng-container>
          </div>
        </div>
        <!--        Sm view-->
        <div class="sm-heading-card d-flex d-xxl-none flex-column position-relative">
          <div class="sm-heading-card__top">
                      <span class="fw-medium fs-18 text-uppercase">
                      <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng"
                                           [itLabel]="event?.nameIta" [siLabel]="event?.nameSlo"
                                           [bsLabel]="event?.nameBs" [defaultLanguage]="event?.defaultLanguage"
                                           [languages]="languages"/>
                      </span>
            <div class="d-flex pt-2">
              <ng-container
                *ngTemplateOutlet="sportBadge; context: { event: event, t: t, isWhiteBadge: true }"></ng-container>
            </div>
            <div class="d-flex flex-row align-items-center pt-2">
              <div class="me-2 icon-wrapper">
                <img src="assets/icons/icons-alt/route-alt-1.svg" alt="Location"/>
              </div>
              <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-width: 0;"
                   class="flex-grow-1">
                @for (length of lengths;track length;let idx = $index) {
                  {{length | raceLengthFormat: translocoService.getActiveLang()}}
                  @if (idx < lengths.length - 1) {
                    <span class="race-length-wrapper__separator">&nbsp;|&nbsp;</span>
                  }
                }
              </div>
            </div>
            <div class="d-inline-flex flex-row pt-1">
              <div class="pe-1 d-flex">
                <div class="me-2 icon-wrapper">
                  <img src="assets/icons/icons-alt/location-alt.svg" alt="Location"/>
                </div>
                <p class="regular">
                  @if (event?.city) { {{event?.city}}}
                  @if (event?.country) {{{','}} }
                  @if (eventCountry?.iocCode) { {{eventCountry?.iocCode}} }
                </p>
              </div>
            </div>
            <div class="d-flex pb-1 align-items-center">
              <div class="px-2 icon-wrapper">
                <img src="assets/icons/icons-alt/calendar-04.svg" alt="Start time"/>
              </div>
              <p class="regular ps-2">
                <app-event-date-display [eventItem]="event"/>
              </p>
            </div>
            <ng-container *ngTemplateOutlet="competitorCount; context: { event: event, t: t }"></ng-container>
          </div>
          <div class="sm-heading-card__bottom">
            <div class="save-share-box-xs pe-3">
              <app-save-share [eventDetails]="event" [languages]="languages"
                              [isPreviewComponent]="componentType === EventDetailsComponentType.PREVIEW"
                              [isXsComponent]="true"/>
            </div>
            <img src="{{event?.imageMedium || ''}}" alt="Event details" class="img-fluid img-size"
                 [sportOne]="event?.sportOne" [sportTwo]="event?.sportTwo" appImageFallback>
          </div>
        </div>
      </div>
      <app-nav-tabs>
        @if (event?.status !== EventStatus.FINISHED) {
          <app-nav-tab [title]="t('app.common.races')" [itemId]="1">
            <ng-template>
              <div class="pt-16 pb-16">
                @for (item of event?.racesList;track item.id;let isLast = $last) {
                  <app-race-grid-item [logoPath]="event!.imageMedium" [currencyLabel]="eventCurrency" [race]="item"
                                      [eventItem]="event" [isLast]="isLast" [languages]="languages"
                                      [hideRegistration]="componentType === EventDetailsComponentType.MY_PAST || componentType === EventDetailsComponentType.MY_UPCOMING"
                                      [countries]="countries"/>
                }
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab
            [title]="isMobile ? t('events.details.event.info.short') : t('events.details.event.info')"
            [itemId]="2">
            <ng-template>
              <app-event-info-tab [event]="event" [languages]="languages"/>
            </ng-template>
          </app-nav-tab>
        }
        @if (!hideCompetitors) {
          <app-nav-tab
            [title]="isMobile ? t('race.details.competitors.short') : t('race.details.competitors')"
            [itemId]="4">
            <ng-template>
              <div class="content-box mt-16">
                <app-competitor-table [languages]="languages" [filteringEnabled]="true" [event]="competitorTableEvent" [categories]="categories"
                                      [raceSettingsList]="settingsList" [countries]="countries"
                                      [race]="(componentType === EventDetailsComponentType.MY_PAST || componentType === EventDetailsComponentType.MY_UPCOMING) ? event?.racesList?.at(0) : undefined"
                                      [allowOnlyRaceView]="(componentType === EventDetailsComponentType.MY_PAST || componentType === EventDetailsComponentType.MY_UPCOMING) ? true : false"
                                      [applicationFormSettingsList]="applicationFormSettingsList" [genders]="genders"
                                      [showEmptyState]="true" [showHeader]="false" [competitors]="competitors"
                                      [tableMode]="CompetitorTableType.EVENT_VIEW" [raceFilteringEnabled]="true"
                                      [showLoadMoreButton]="true"/>

              </div>
            </ng-template>
          </app-nav-tab>
        }
        @if ((event?.racesList?.length ?? 0) > 0) {
          <app-nav-tab [title]="t('events.details.results')" [itemId]="5">
            <ng-template>
              <div class="content-box mt-16">
                <app-results-table [results]="results" [languages]="languages" [categories]="categories"
                                   [genders]="genders" [race]="event!.racesList![0]" [filteringEnabled]="true"
                                   [showEmptyState]="true" [event]="event" [showBorderBottom]="false"/>
              </div>
            </ng-template>
          </app-nav-tab>
        }
        <app-nav-tab [title]="t('events.details.contacts')" [itemId]="3">
          <ng-template>
            <app-event-contacts-tab [event]="event" [languages]="languages"/>
          </ng-template>
        </app-nav-tab>

        @if (event?.status !== EventStatus.FINISHED && environment.isMapVisible) {
          <app-nav-tab [title]="t('organiser.event.details.tab.checkpoints')" [itemId]="6">
            <ng-template>
              <div class="content-box mt-16">
                <race-map-modal [eventItem]="event" [languages]="languages"></race-map-modal>
              </div>
            </ng-template>
          </app-nav-tab>
        }
      </app-nav-tabs>
    </div>
  </ng-template>
</ng-container>

<ng-template #sportBadge let-event="event" let-t="t" let-isWhiteBadge="isWhiteBadge">
  <ng-container *ngIf="event?.sportOne || event?.sportTwo">
    <ng-container *ngIf="event?.sportOne; else showSportTwo">
      <p class="badge d-inline-flex fs-14-16" [ngClass]="{ 'white-badge': isWhiteBadge }">
        {{t("app.common.sports." + event?.sportOne)}} </p>
    </ng-container>
    <ng-template #showSportTwo>
      <ng-container *ngIf="event?.sportTwo">
        <p class="badge d-inline-flex fs-14-16" [ngClass]="{ 'white-badge': isWhiteBadge }">
          {{t("app.common.sports." + event?.sportTwo)}} </p>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-template>


<ng-template #competitorCount let-event="event" let-t="t" >
  <div class="d-flex pb-1 align-items-center">
    @if (event?.competitorCount) {
      <div class="pe-2 d-flex">
        <img src="assets/icons/icons-alt/applicants_teal.svg" alt="applicants"/>
      </div>
      <p class="regular">
        <span>
          {{event?.status !== EventStatus.FINISHED ?
                      (event?.competitorCount?.total ?? "-") :
                      ((event?.competitorCount?.finished ?? 0) +
                      (event?.competitorCount?.disqualified ?? 0) +
                      (event?.competitorCount?.didNotFinished ?? 0) +
                      (event?.competitorCount?.timeLimitExceeded ?? 0)) ?? "-"
          }}
        </span>
        @if ((event?.status !== EventStatus.FINISHED && event?.competitorCount?.registeredCountriesCount != 0)
        || (event?.status === EventStatus.FINISHED && event?.competitorCount?.finishedCountriesCount != 0)) {
          <span class="race-length-wrapper__separator">|</span>
          <span class="ps-1">{{t('explore.countries')}}</span>
          <span class="">
            {{event?.status !== EventStatus.FINISHED ?
                      (event?.competitorCount?.registeredCountriesCount ?? "-") :
                      (event?.competitorCount?.finishedCountriesCount ?? "-")
            }}
          </span>
        }
      </p>
    }
  </div>
</ng-template>

